// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2xBpD","info":"Note_info__39pPn","note":"Note_note__95r6F","actions":"Note_actions__31o53"};